module.exports = __webpack_public_path__ + "img/saxophone-fire.59677551.svg";